import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { downloadInvoice, resetInvoiceDownload } from '../store/invoiceSlice';

export const useInvoice = () => {
  const dispatch = useDispatch();
  
  const {
    downloadingInvoice,
    downloadUrl,
    invoiceFilename,
    downloadError,
    downloadSuccess,
  } = useSelector((state) => state.invoice);

  const triggerInvoiceDownload = useCallback((payload) => {
    if (!payload?.companyId || !payload?.invoiceId) {
      console.error('Missing required fields: companyId and invoiceId');
      return;
    }
    dispatch(downloadInvoice(payload));
  }, [dispatch]);

  const downloadInvoicePdf = useCallback(() => {
    if (!downloadUrl) {
      console.warn('No download URL available');
      return;
    }

    try {
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.download = invoiceFilename || 'invoice.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading invoice:', error);
    }
  }, [downloadUrl, invoiceFilename]);

  const clearDownloadState = useCallback(() => {
    dispatch(resetInvoiceDownload());
  }, [dispatch]);

  return {
    isDownloading: downloadingInvoice,
    downloadUrl,
    invoiceFilename,
    downloadError,
    downloadSuccess,
    
    triggerInvoiceDownload,
    downloadInvoicePdf,
    resetDownload: clearDownloadState,
  };
};

export default useInvoice;
